import { Comment, createVNode, type Slot, Text, VNode } from "vue";

export function renderSingle<T>(
    slot?: Slot<T>,
    ...args: Parameters<Slot<T>>
): VNode | VNode[] {
    if (!slot) {
        return createVNode(Comment);
    }

    const rendered = slot(...args);

    if (rendered.length === 1) {
        return rendered[0];
    }

    return rendered;
}

export function renderSingleText<T>(
    slot?: Slot<T>,
    ...args: Parameters<Slot<T>>
): string | undefined {
    const single = renderSingle(slot, ...args);

    if (Array.isArray(single)) {
        return;
    }

    if (single.type !== Text || typeof single.children !== "string") {
        return;
    }

    return single.children;
}
